module.exports = __webpack_public_path__ + "static/media/Project Board Feedback_1576214653535.51832ce4.mp4";